import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ShowDocumentComponent } from 'src/app/feature-module/documents/component/show-document/show-document.component';

import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { DocumentInfo } from '../../models/DocumentInfo';
import { SentDocumentInfo } from '../../models/SentDocumentInfo';
import { ClaimDataService } from 'src/app/feature-module/claims-data/service/claim-data.service';

@Component({
  selector: 'app-sent-docs',
  templateUrl: './sent-docs.component.html',
  styleUrls: ['./sent-docs.component.scss']
})
export class SentDocsComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
    private documentService: DocumentService,
    private claimDataService: ClaimDataService,
    private customDialogService: CustomDialogService,
    private translateService: TranslateService) { }

  claimId: string;
  isClaimArchived = false;

  sentDocuments$: Observable<SentDocumentInfo[]>;
  public setSpecificDataCallback: Function;

  
  @ViewChild("sentDocsDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  
  ngOnInit() {
    this.claimId = this.activatedRoute.snapshot.paramMap.get('id');
    this.checkIsClaimArchived();
    this.getSentDocuments();
  }

  getSentDocuments(){
    this.sentDocuments$ = this.documentService.getSentDocuments( this.claimId ).pipe(debounceTime(1000));
  }

    checkIsClaimArchived(){
    this.claimDataService.checkIsClaimArchive(this.claimId).subscribe({
      next: (r) => {
        this.isClaimArchived = r;
      },
    });
  }

  showContent(documentInfo:DocumentInfo){

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      minHeight: '60vh',
       minWidth: '60vw',
       maxHeight: '90vh',
       maxWidth: '90vw',
      appendTo: this.containerRef,
      title: `${this.translateService.instant('claims-center.claimDocumentation.showContentOfSentDocument')}  (${documentInfo.name})`,
      dialogInputs: {
        documentInfo : documentInfo
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

}



